import Avatar from '@mui/material/Avatar';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserWithTribeMembershipDetails } from 'src/api/user';
import avatar from 'src/assets/images/logos/default-profile.png';
import { PathRoutes } from 'src/const/Routes/PathRoutes';
import styles from './UserInfo.module.scss';

export const UserInfo: FC<UserWithTribeMembershipDetails> = ({
  result,
  comment_count,
  like_count,
}) => {
  const navigate = useNavigate();

  const matches = useMediaQuery('(max-width:768px)');

  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: matches ? `url(${result.avatar_url || avatar})` : '',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className={styles.avatar}>
        <Avatar
          src={result?.avatar_url || avatar}
          sx={{
            width: 300,
            height: 300,
            borderRadius: '50%',
            background: '#f1f1f1',
          }}
        >
          {result.full_name?.charAt(0)}
        </Avatar>
      </div>
      <div className={styles.info}>
        <div className={styles.data}>
          <div className={styles.title}>{result.full_name}</div>
        </div>

        <div>
          <div className={styles.containerMiddle}>
            <div className={styles.infoMiddle}>
              <span>Comments:</span> {comment_count}
            </div>
            <div className={styles.infoMiddle}>
              <span>Likes:</span> {like_count}
            </div>
          </div>
          <div className={styles.bio}>
            <div>
              <span>{result.bio}</span>
            </div>
          </div>
        </div>
        <div className={styles.btns}>
          <button
            onClick={() => navigate(PathRoutes.EditProfileRoute)}
            className={styles.btn}
          >
            Edit Profile
          </button>
          <button
            className={styles.btn}
            onClick={() => navigate(PathRoutes.CreateCircleRoute)}
          >
            Create Circle
          </button>
        </div>
      </div>
    </div>
  );
};
